import React from "react";
import { PrimaryButton, DefaultButton, Stack } from "@fluentui/react";

export interface AppItem {
    id: number;
    title: string;
    image: string;
}

interface Props {
    apps: AppItem[];
    selectedApps: number[];
    setSelectedApps: (apps: number[]) => void;
    onContinue: () => void;
    onBack: () => void;
}

export const StepApps: React.FC<Props> = ({
    apps,
    selectedApps,
    setSelectedApps,
    onContinue,
    onBack
}) => {

    const toggleApp = (id: number) => {

        if (selectedApps.includes(id)) {
            setSelectedApps(selectedApps.filter(a => a !== id));
        } else {
            setSelectedApps([...selectedApps, id]);
        }

    };

    return (

        <div className="step-apps-container">

            <h2 className="create-account-heading">Select Apps</h2>

            <div className="step-apps-intro">
                Select the ZedX apps you would like to enable in your environment.
                Available apps may vary depending on your edition, sector and country.
            </div>

            <div className="apps-selector">

                {apps.map(app => {

                    const isSelected = selectedApps.includes(app.id);

                    return (

                        <div
                            key={app.id}
                            className={`app-tile ${isSelected ? "selected" : ""}`}
                            onClick={() => toggleApp(app.id)}
                        >

                            <img
                                src={app.image}
                                alt={app.title}
                            />

                            <div className="app-title">
                                {app.title}
                            </div>

                        </div>

                    );

                })}

            </div>

            <div className="step-apps-enterprise-note">

                If you require an Enterprise environment, please select the
                Corporate edition and complete the setup.

            </div>

            <Stack horizontal tokens={{ childrenGap: 12 }} className="step-actions-btns">
                <DefaultButton text="Back" onClick={onBack} />
                <PrimaryButton text="Continue" disabled={selectedApps.length === 0} onClick={onContinue} />
            </Stack>

        </div>

    );

};